// Types du module onboarding.
//
// L'état SERVEUR et l'état LOCAL sont volontairement séparés :
//  - le serveur fait foi pour l'avancement réel (a-t-il un voyageur ? une demande ?) ;
//  - le local ne mémorise que des préférences d'affichage et le visa en cours de choix.
// Ne jamais déduire l'avancement du local : voir le commentaire de StatutEtat.

export type EtapeId = 'compte' | 'destination' | 'voyageur' | 'demande';

/**
 * 'inconnu' = le backend n'a pas répondu.
 * Dans ce cas la feuille de route ne s'affiche PAS : les services de Services.ts
 * font `catch { return [] }`, donc une règle « 0 voyageur => onboarding » relancerait
 * le parcours à un client qui en a cinq dès que l'API tousse.
 */
export type StatutEtat = 'chargement' | 'ok' | 'inconnu';

export interface EtatOnboarding {
  statut: StatutEtat;
  nbVoyageurs: number;
  nbDemandes: number;
  onboardingTermineLe: string | null;
  onboardingMasque: boolean;
  estSociete: boolean;
}

/** Visa mémorisé au moment où l'on quitte VisasScreen, pour pouvoir y revenir. */
export interface VisaMemorise {
  titre: string;
  route: string;
  paysLibelle: string;
  urlFlag: string;
  /**
   * Le `state` EXACT passé à navigate(). Indispensable pour rouvrir le formulaire
   * du pays à l'identique : il y lit title, prixconsulat, prixintervention,
   * url_flag, validite, informations et commentaires.
   */
  state: Record<string, any>;
  le: string;
}

export interface OnboardingLocal {
  version: 1;
  bienvenueVue: boolean;
  carteRepliee: boolean;
  masqueeLe: string | null;
  /** Format 'jj/mm/aaaa', identique à celui qu'attendent les 56 formulaires. */
  dateDepart: string | null;
  visaChoisi: VisaMemorise | null;
  celebrations: { voyageur: boolean; demande: boolean };
}

export const ETAT_INCONNU: EtatOnboarding = {
  statut: 'inconnu',
  nbVoyageurs: 0,
  nbDemandes: 0,
  onboardingTermineLe: null,
  onboardingMasque: false,
  estSociete: false,
};

export const LOCAL_PAR_DEFAUT: OnboardingLocal = {
  version: 1,
  bienvenueVue: false,
  carteRepliee: false,
  masqueeLe: null,
  dateDepart: null,
  visaChoisi: null,
  celebrations: { voyageur: false, demande: false },
};
